// Auto-generated wholesale locations data
// Generated on: 2026-02-27T17:20:17.337Z
// Total locations: 189

const LOCATIONS = [
  {
    "name": "Coffee Corral(Pudgee's Eatery)",
    "address": "8431 E Rosko Ct, Floral City, FL 34436",
    "city": "Floral City",
    "state": "FL",
    "zip": "34436",
    "phone": "+13524195801",
    "type": "shop",
    "lat": 28.7211775,
    "lng": -82.3076709
  },
  {
    "name": "Gerald Oriol",
    "address": "233 Main Street, Nashua, NH 03060",
    "city": "Nashua",
    "state": "NH",
    "zip": "03060",
    "phone": "",
    "type": "shop",
    "lat": 42.7579086,
    "lng": -71.4643275
  },
  {
    "name": "Pickers Off Main",
    "address": "112 Sparkman St SW, Hartselle, AL 35640",
    "city": "Hartselle",
    "state": "AL",
    "zip": "35640",
    "phone": "+12562807803",
    "type": "shop",
    "lat": 34.4349587,
    "lng": -86.9332114
  },
  {
    "name": "All Occasions Events & Floral, LLC",
    "address": "110 N James St, Ludington, MI 49431",
    "city": "Ludington",
    "state": "MI",
    "zip": "49431",
    "phone": "+12314259425",
    "type": "shop",
    "lat": 43.9560114,
    "lng": -86.44768739999999
  },
  {
    "name": "99 Boutique",
    "address": "7521 Amanda Cir SW, Huntsville, AL 35802",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35802",
    "phone": "+12566798495",
    "type": "shop",
    "lat": 34.6506196,
    "lng": -86.580338
  },
  {
    "name": "Tosa Coffee Co.",
    "address": "10076 Ford Avenue, Richmond Hill, GA 31324",
    "city": "Richmond Hill",
    "state": "GA",
    "zip": "31324",
    "phone": "+15025330998",
    "type": "shop",
    "lat": 31.9470352,
    "lng": -81.3109642
  },
  {
    "name": "Deborah Young",
    "address": "101 West 12th Street, New York, NY 10011",
    "city": "New York",
    "state": "NY",
    "zip": "10011",
    "phone": "+12059799100",
    "type": "shop",
    "lat": 40.7364731,
    "lng": -73.9978323
  },
  {
    "name": "Wallhouse Coffee",
    "address": "751 Dover Road Northwest, Sugarcreek, OH 44681",
    "city": "Sugarcreek",
    "state": "OH",
    "zip": "44681",
    "phone": "+13304014059",
    "type": "shop",
    "lat": 40.5095128,
    "lng": -81.648895
  },
  {
    "name": "The Frosty Cow",
    "address": "900 Camel Drive, Gillette, WY 82716",
    "city": "Gillette",
    "state": "WY",
    "zip": "82716",
    "phone": "+13076892527",
    "type": "shop",
    "lat": 44.28124469999999,
    "lng": -105.4922927
  },
  {
    "name": "ChubbFathers Burgers",
    "address": "229 Kent Stone Boulevard, Alabaster, AL 35007",
    "city": "Alabaster",
    "state": "AL",
    "zip": "35007",
    "phone": "",
    "type": "shop",
    "lat": 33.2132668,
    "lng": -86.82297919999999
  },
  {
    "name": "Bee on the Brow",
    "address": "16951 county rd 89, mentone, AL 35984",
    "city": "mentone",
    "state": "AL",
    "zip": "35984",
    "phone": "+12565427725",
    "type": "shop",
    "lat": 34.5289756,
    "lng": -85.62604250000001
  },
  {
    "name": "K&K Kind Kups Coffee",
    "address": "85 Camp Road, Cleveland, AL 35049",
    "city": "Cleveland",
    "state": "AL",
    "zip": "35049",
    "phone": "+12056070939",
    "type": "shop",
    "lat": 33.9873508,
    "lng": -86.5842595
  },
  {
    "name": "The Portal Salon, LLC",
    "address": "2614 Lancelot Dr SE, Huntsville, AL 35803",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35803",
    "phone": "+12566587796",
    "type": "shop",
    "lat": 34.6279604,
    "lng": -86.5291948
  },
  {
    "name": "The Soaking Pot",
    "address": "2 Common Ct, North Conway, NH 03860",
    "city": "North Conway",
    "state": "NH",
    "zip": "03860",
    "phone": "6036627035",
    "type": "shop",
    "lat": 44.02344679999999,
    "lng": -71.1132472
  },
  {
    "name": "Jonica's Bakery",
    "address": "1708 Gunter Avenue, Guntersville, AL 35976",
    "city": "Guntersville",
    "state": "AL",
    "zip": "35976",
    "phone": "+12055772387",
    "type": "shop",
    "lat": 34.342194,
    "lng": -86.3085363
  },
  {
    "name": "Sewall House",
    "address": "1027 Crystal Road, Island Falls, ME 04747",
    "city": "Island Falls",
    "state": "ME",
    "zip": "04747",
    "phone": "+16463165151",
    "type": "shop",
    "lat": 46.0087511,
    "lng": -68.2702248
  },
  {
    "name": "Beans coffee truck",
    "address": "25850 Iron Gate Drive, Madison, AL 35756",
    "city": "Madison",
    "state": "AL",
    "zip": "35756",
    "phone": "+15404240791",
    "type": "shop",
    "lat": 34.7410825,
    "lng": -86.86214749999999
  },
  {
    "name": "The Mustard Seed",
    "address": "119 s 18th st, parsons, KS 67357",
    "city": "parsons",
    "state": "KS",
    "zip": "67357",
    "phone": "+16204216454",
    "type": "shop",
    "lat": 37.3397508,
    "lng": -95.2625719
  },
  {
    "name": "Cornerstone Cafe",
    "address": "1400 Leggett Dr, Biloxi, MS 39530",
    "city": "Biloxi",
    "state": "MS",
    "zip": "39530",
    "phone": "+16016243001",
    "type": "shop",
    "lat": 30.3956806,
    "lng": -88.920119
  },
  {
    "name": "Glory Bound Trading Company",
    "address": "7972 U.S. 45, Meridian, MS 39305",
    "city": "Meridian",
    "state": "MS",
    "zip": "39305",
    "phone": "+16019387423",
    "type": "shop",
    "lat": 32.4563441,
    "lng": -88.62256049999999
  },
  {
    "name": "The Henderson Farms",
    "address": "8294 North Briarhopper Road, Monrovia, IN 46157",
    "city": "Monrovia",
    "state": "IN",
    "zip": "46157",
    "phone": "+13176009695",
    "type": "shop",
    "lat": 39.5440796,
    "lng": -86.5040439
  },
  {
    "name": "Kymber Arthaud",
    "address": "PO Box 942, Boise City, OK 73933",
    "city": "Boise City",
    "state": "OK",
    "zip": "73933",
    "phone": "+15805171040",
    "type": "shop",
    "lat": 36.7294675,
    "lng": -102.5132419
  },
  {
    "name": "Just Another Shop",
    "address": "101 East Broad Street, Eufaula, AL 36027",
    "city": "Eufaula",
    "state": "AL",
    "zip": "36027",
    "phone": "+13342324401",
    "type": "shop",
    "lat": 31.892641,
    "lng": -85.14542469999999
  },
  {
    "name": "Vintage Garden Florist and Gifts",
    "address": "1403 South Main Street, Poplarville, MS 39470",
    "city": "Poplarville",
    "state": "MS",
    "zip": "39470",
    "phone": "+16017955013",
    "type": "shop",
    "lat": 30.8279794,
    "lng": -89.5231838
  },
  {
    "name": "Sturbridge Coffee House",
    "address": "407B Main Street, Sturbridge, MA 01566",
    "city": "Sturbridge",
    "state": "MA",
    "zip": "01566",
    "phone": "+15083472288",
    "type": "shop",
    "lat": 42.11124119999999,
    "lng": -72.0965018
  },
  {
    "name": "Seabird Coffee CO",
    "address": "24 S Main St, Cohasset, MA 02025",
    "city": "Cohasset",
    "state": "MA",
    "zip": "02025",
    "phone": "+17815272069",
    "type": "shop",
    "lat": 42.2409261,
    "lng": -70.8020817
  },
  {
    "name": "Dow Gardens",
    "address": "2203 Eastman Avenue, Midland, MI 48640",
    "city": "Midland",
    "state": "MI",
    "zip": "48640",
    "phone": "+19896312677",
    "type": "shop",
    "lat": 43.6278634,
    "lng": -84.248294
  },
  {
    "name": "Strong Tower Bible Church",
    "address": "712 Founders Pointe Blvd, Franklin, TN 37064",
    "city": "Franklin",
    "state": "TN",
    "zip": "37064",
    "phone": "",
    "type": "shop",
    "lat": 35.9320434,
    "lng": -86.9016458
  },
  {
    "name": "Michael Fye",
    "address": "269 Grooms Road, Fayetteville, GA 30215",
    "city": "Fayetteville",
    "state": "GA",
    "zip": "30215",
    "phone": "+14047253182",
    "type": "shop",
    "lat": 33.3464607,
    "lng": -84.47851089999999
  },
  {
    "name": "Coffee Trough",
    "address": "709 Davis Ave, Corning, IA 50841",
    "city": "Corning",
    "state": "IA",
    "zip": "50841",
    "phone": "+14342621932",
    "type": "shop",
    "lat": 40.9893613,
    "lng": -94.7348241
  },
  {
    "name": "Meri Moon",
    "address": "618 Main street, Montevallo, AL 35115",
    "city": "Montevallo",
    "state": "AL",
    "zip": "35115",
    "phone": "+12057468721",
    "type": "shop",
    "lat": 33.0997458,
    "lng": -86.8635187
  },
  {
    "name": "Fontana Home",
    "address": "158 Fontana Blvd, Fontana, WI 53125",
    "city": "Fontana",
    "state": "WI",
    "zip": "53125",
    "phone": "+12563945088",
    "type": "shop",
    "lat": 42.5493363,
    "lng": -88.5784613
  },
  {
    "name": "Black Hills Bagels",
    "address": "913 Mount Rushmore Road, Rapid City, SD 57701",
    "city": "Rapid City",
    "state": "SD",
    "zip": "57701",
    "phone": "+16056462402",
    "type": "shop",
    "lat": 44.0768766,
    "lng": -103.2327331
  },
  {
    "name": "The Rose & Hook LLC",
    "address": "210 South Central Avenue, Eureka, MO 63025",
    "city": "Eureka",
    "state": "MO",
    "zip": "63025",
    "phone": "+15734215621",
    "type": "shop",
    "lat": 38.500747,
    "lng": -90.6277637
  },
  {
    "name": "The Water Hole",
    "address": "13976 FM 1050 #549, Utopia, TX 78884",
    "city": "Utopia",
    "state": "TX",
    "zip": "78884",
    "phone": "+18302791322",
    "type": "shop",
    "lat": 29.6152274,
    "lng": -99.5269926
  },
  {
    "name": "The Farmers Daughter",
    "address": "485 main street, ferndale, CA 95536",
    "city": "ferndale",
    "state": "CA",
    "zip": "95536",
    "phone": "+17074077550",
    "type": "shop",
    "lat": 40.5772047,
    "lng": -124.2633532
  },
  {
    "name": "Madison Church of the Nazarene",
    "address": "8234 Old Madison Pike, Madison, AL 35758",
    "city": "Madison",
    "state": "AL",
    "zip": "35758",
    "phone": "+12565271437",
    "type": "shop",
    "lat": 34.7064516,
    "lng": -86.7314899
  },
  {
    "name": "Salty pup Coffee",
    "address": "6800 Gulfport Boulevard South, South Pasadena, FL 33707",
    "city": "South Pasadena",
    "state": "FL",
    "zip": "33707",
    "phone": "+17275168905",
    "type": "shop",
    "lat": 27.7567405,
    "lng": -82.7334377
  },
  {
    "name": "The Country Barn Gift Shop",
    "address": "2869 Parkway, Pigeon Forge, TN 37863",
    "city": "Pigeon Forge",
    "state": "TN",
    "zip": "37863",
    "phone": "+18653651162",
    "type": "shop",
    "lat": 35.7986849,
    "lng": -83.56722479999999
  },
  {
    "name": "Wild Mountain Trading Co",
    "address": "114 N Main St, Hendersonville, NC 28792",
    "city": "Hendersonville",
    "state": "NC",
    "zip": "28792",
    "phone": "+13212710748",
    "type": "shop",
    "lat": 35.3146241,
    "lng": -82.4594457
  },
  {
    "name": "Lizzie's Place",
    "address": "754 Cox Creek Parkway, Florence, AL 35630",
    "city": "Florence",
    "state": "AL",
    "zip": "35630",
    "phone": "+18018955248",
    "type": "shop",
    "lat": 34.843972,
    "lng": -87.6639396
  },
  {
    "name": "La Farm Bakery",
    "address": "4248 NW Cary Pkwy, Cary, NC 27513",
    "city": "Cary",
    "state": "NC",
    "zip": "27513",
    "phone": "",
    "type": "shop",
    "lat": 35.790754,
    "lng": -78.8275015
  },
  {
    "name": "Sweet Foam Alabama",
    "address": "1930 Markt Platz Center SW, Cullman, AL 35055",
    "city": "Cullman",
    "state": "AL",
    "zip": "35055",
    "phone": "+12512691133",
    "type": "shop",
    "lat": 34.1437581,
    "lng": -86.7516942
  },
  {
    "name": "Kindred Cottage",
    "address": "865 Alabama 243, Haleyville, AL 35565",
    "city": "Haleyville",
    "state": "AL",
    "zip": "35565",
    "phone": "+18634506474",
    "type": "shop",
    "lat": 34.3165086,
    "lng": -87.5784843
  },
  {
    "name": "Do Goods Mercantile Co",
    "address": "202 St Michael Street, Mobile, AL 36602",
    "city": "Mobile",
    "state": "AL",
    "zip": "36602",
    "phone": "+12516543039",
    "type": "shop",
    "lat": 30.6931458,
    "lng": -88.04387779999999
  },
  {
    "name": "Turbo Coffee",
    "address": "2010 8th Street, Tuscaloosa, AL 35401",
    "city": "Tuscaloosa",
    "state": "AL",
    "zip": "35401",
    "phone": "+12052063444",
    "type": "shop",
    "lat": 33.208512,
    "lng": -87.5622396
  },
  {
    "name": "Katie McCarl",
    "address": "873 V C Lane, Oneonta, AL 35121",
    "city": "Oneonta",
    "state": "AL",
    "zip": "35121",
    "phone": "2058639527",
    "type": "shop",
    "lat": 33.93603030000001,
    "lng": -86.55892279999999
  },
  {
    "name": "Erin Elliott",
    "address": "10440 Long Meadow Rd, Madison, AL 35756",
    "city": "Madison",
    "state": "AL",
    "zip": "35756",
    "phone": "+12567140146",
    "type": "shop",
    "lat": 34.7060801,
    "lng": -86.800907
  },
  {
    "name": "Callaway Gardens Resort, Inc Purchasing Warehouse",
    "address": "18718 US Highway 27, Pine Mountain, GA 31822",
    "city": "Pine Mountain",
    "state": "GA",
    "zip": "31822",
    "phone": "+17066165158",
    "type": "shop",
    "lat": 32.8421393,
    "lng": -84.8431394
  },
  {
    "name": "Four Knights Coffee",
    "address": "109 North Main Street, Arab, AL 35016",
    "city": "Arab",
    "state": "AL",
    "zip": "35016",
    "phone": "+12566732727",
    "type": "shop",
    "lat": 34.3178396,
    "lng": -86.4960321
  },
  {
    "name": "106 Jefferson, Curio by Hilton",
    "address": "106 Jefferson Street South, Huntsville, AL 35801",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35801",
    "phone": "+12563610181",
    "type": "shop",
    "lat": 34.7308674,
    "lng": -86.5864579
  },
  {
    "name": "Auburn Oil Booksellers",
    "address": "149 E Magnolia Ave suite a, Auburn, AL 36830",
    "city": "Auburn",
    "state": "AL",
    "zip": "36830",
    "phone": "+13346636731",
    "type": "shop",
    "lat": 32.6067415,
    "lng": -85.4805911
  },
  {
    "name": "Renaissance Montgomery Hotel and Spa",
    "address": "201 Tallapoosa Street, Montgomery, AL 36104",
    "city": "Montgomery",
    "state": "AL",
    "zip": "36104",
    "phone": "+13344815000",
    "type": "shop",
    "lat": 32.3784922,
    "lng": -86.31263679999999
  },
  {
    "name": "Dollywood's Heartsong Resort",
    "address": "1130 Wagner Drive, Sevierville, TN 37862",
    "city": "Sevierville",
    "state": "TN",
    "zip": "37862",
    "phone": "+14192391199",
    "type": "shop",
    "lat": 35.8596688,
    "lng": -83.5300376
  },
  {
    "name": "Vienna Coffee House",
    "address": "212 College Street, Maryville, TN 37804",
    "city": "Maryville",
    "state": "TN",
    "zip": "37804",
    "phone": "+18653566067",
    "type": "shop",
    "lat": 35.7565203,
    "lng": -83.96904289999999
  },
  {
    "name": "Southern Girl Coffee Company",
    "address": "31 East Choccolocco Street, Oxford, AL 36203",
    "city": "Oxford",
    "state": "AL",
    "zip": "36203",
    "phone": "+12565258817",
    "type": "shop",
    "lat": 33.6152513,
    "lng": -85.8343251
  },
  {
    "name": "Float Huntsville",
    "address": "543 Mountain Gap Rd SE, Huntsville, AL 35803",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35803",
    "phone": "+12569293194",
    "type": "shop",
    "lat": 34.6310703,
    "lng": -86.55536529999999
  },
  {
    "name": "Concord Hospitality",
    "address": "111 West Markham St, Little Rock, AR 72201",
    "city": "Little Rock",
    "state": "AR",
    "zip": "72201",
    "phone": "+15013707055",
    "type": "shop",
    "lat": 34.7478051,
    "lng": -92.2712762
  },
  {
    "name": "MAD LLAMA COFFEE",
    "address": "5001 Kenwood Rd, CINCINNATI, OH 45227",
    "city": "CINCINNATI",
    "state": "OH",
    "zip": "45227",
    "phone": "+15133282129",
    "type": "shop",
    "lat": 39.16032999999999,
    "lng": -84.3861823
  },
  {
    "name": "The Greenroom",
    "address": "5909 University Drive, Huntsville, AL 35806",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35806",
    "phone": "+12563359636",
    "type": "shop",
    "lat": 34.74001,
    "lng": -86.6644532
  },
  {
    "name": "The Sipping Flea",
    "address": "6965 Richmond Road, Williamsburg, VA 23188",
    "city": "Williamsburg",
    "state": "VA",
    "zip": "23188",
    "phone": "+17575083782",
    "type": "shop",
    "lat": 37.3550071,
    "lng": -76.7648773
  },
  {
    "name": "Besso's Coffee",
    "address": "112 West Main Street, Henderson, TN 38340",
    "city": "Henderson",
    "state": "TN",
    "zip": "38340",
    "phone": "6157145657",
    "type": "shop",
    "lat": 35.4388592,
    "lng": -88.6419933
  },
  {
    "name": "Muletown Coffee",
    "address": "21 Public Square, Columbia, TN 38401",
    "city": "Columbia",
    "state": "TN",
    "zip": "38401",
    "phone": "+19317979261",
    "type": "shop",
    "lat": 35.6144034,
    "lng": -87.03420469999999
  },
  {
    "name": "THE CORNER CUP MICRO-BAKERY",
    "address": "802 Hawks Circle Drive, Hillsboro, MO 63050",
    "city": "Hillsboro",
    "state": "MO",
    "zip": "63050",
    "phone": "+13148084481",
    "type": "shop",
    "lat": 38.2384837,
    "lng": -90.57178359999999
  },
  {
    "name": "Say's Restaurant",
    "address": "PO BOX 161, New Harmony, IN 47631",
    "city": "New Harmony",
    "state": "IN",
    "zip": "47631",
    "phone": "+17655328324",
    "type": "shop",
    "lat": 38.1297678,
    "lng": -87.93502989999999
  },
  {
    "name": "Honest Coffee Roasters",
    "address": "960 Oxmoor Road, Homewood, AL 35209",
    "city": "Homewood",
    "state": "AL",
    "zip": "35209",
    "phone": "+12052307080",
    "type": "shop",
    "lat": 33.4739387,
    "lng": -86.8084313
  },
  {
    "name": "Red River Gorge Gift Shop",
    "address": "693 Natural Bridge Rd, Slade, KY 40376",
    "city": "Slade",
    "state": "KY",
    "zip": "40376",
    "phone": "+16066685214",
    "type": "shop",
    "lat": 37.7910771,
    "lng": -83.69862909999999
  },
  {
    "name": "The Beer Syrup Co.",
    "address": "425 East Burnett Avenue, Louisville, KY 40215",
    "city": "Louisville",
    "state": "KY",
    "zip": "40215",
    "phone": "+15024945076",
    "type": "shop",
    "lat": 38.2262652,
    "lng": -85.74972269999999
  },
  {
    "name": "Simply Healthy",
    "address": "Sportsplex Drive, Muscle Shoals, AL 35674",
    "city": "Muscle Shoals",
    "state": "AL",
    "zip": "35674",
    "phone": "+12564153500",
    "type": "shop",
    "lat": 34.717604,
    "lng": -87.6662482
  },
  {
    "name": "Clumpies",
    "address": "3405 Saint Elmo Avenue, Chattanooga, TN 37409",
    "city": "Chattanooga",
    "state": "TN",
    "zip": "37409",
    "phone": "+14234982678",
    "type": "shop",
    "lat": 35.0170402,
    "lng": -85.3253843
  },
  {
    "name": "Coffee break cafe",
    "address": "4265 Woodbine Road, Pace, FL 32571",
    "city": "Pace",
    "state": "FL",
    "zip": "32571",
    "phone": "+18507480535",
    "type": "shop",
    "lat": 30.5937187,
    "lng": -87.17878379999999
  },
  {
    "name": "Rejuvenation Spa",
    "address": "4373 Lynx Paw Trail, Valrico, FL 33596",
    "city": "Valrico",
    "state": "FL",
    "zip": "33596",
    "phone": "+18133820843",
    "type": "shop",
    "lat": 27.8768661,
    "lng": -82.2224514
  },
  {
    "name": "Golden Leaf Studios",
    "address": "2901 Brooks St, Missoula, MT 59801",
    "city": "Missoula",
    "state": "MT",
    "zip": "59801",
    "phone": "+14062403957",
    "type": "shop",
    "lat": 46.845123,
    "lng": -114.027909
  },
  {
    "name": "The Corner Soak and Spa",
    "address": "501 3rd Street Southwest, Cullman, AL 35055",
    "city": "Cullman",
    "state": "AL",
    "zip": "35055",
    "phone": "+12052813965",
    "type": "shop",
    "lat": 34.1737187,
    "lng": -86.84741520000001
  },
  {
    "name": "Wayfinder Coffee Co",
    "address": "6140 Austin Bluffs Pkwy, Colorado Springs, CO 80923",
    "city": "Colorado Springs",
    "state": "CO",
    "zip": "80923",
    "phone": "+17192642386",
    "type": "shop",
    "lat": 38.9215159,
    "lng": -104.7394902
  },
  {
    "name": "Wolf Creek Indian Village",
    "address": "6394 North Scenic Highway, Bastian, VA 24314",
    "city": "Bastian",
    "state": "VA",
    "zip": "24314",
    "phone": "+12766883438",
    "type": "shop",
    "lat": 37.181194,
    "lng": -81.13891129999999
  },
  {
    "name": "Cottage Kitchen and Market",
    "address": "2 Mimosa Drive, Chattanooga, TN 37415",
    "city": "Chattanooga",
    "state": "TN",
    "zip": "37415",
    "phone": "+14238341784",
    "type": "shop",
    "lat": 35.1524913,
    "lng": -85.2699724
  },
  {
    "name": "Java Espress Beverage Company",
    "address": "4942 West 12600 South, Herriman, UT 84096",
    "city": "Herriman",
    "state": "UT",
    "zip": "84096",
    "phone": "+12085211297",
    "type": "shop",
    "lat": 40.522874,
    "lng": -112.008878
  },
  {
    "name": "Chocolate Moonshine",
    "address": "1911 Leesburg Grove City Rd., Grove City, PA 16127",
    "city": "Grove City",
    "state": "PA",
    "zip": "16127",
    "phone": "+14128498927",
    "type": "shop",
    "lat": 41.1385211,
    "lng": -80.15690060000001
  },
  {
    "name": "U. S. Space  & Rocket Center",
    "address": "1 Tranquility Base, Huntsville, AL 35805",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35805",
    "phone": "+12564970804",
    "type": "shop",
    "lat": 34.7111322,
    "lng": -86.6539363
  },
  {
    "name": "Fiddledee Dee",
    "address": "104 Renee Street, Tuscumbia, AL 35674",
    "city": "Tuscumbia",
    "state": "AL",
    "zip": "35674",
    "phone": "+12567624988",
    "type": "shop",
    "lat": 34.7151816,
    "lng": -87.7237459
  },
  {
    "name": "The Heights at Monte Sano",
    "address": "1001 Heights Trail Southeast, Brownsboro, AL 35741",
    "city": "Brownsboro",
    "state": "AL",
    "zip": "35741",
    "phone": "+12569373700",
    "type": "shop",
    "lat": 34.6885061,
    "lng": -86.5039865
  },
  {
    "name": "Holly Fleming",
    "address": "N. 5901 County Road DD, Burlington, WI 53105",
    "city": "Burlington",
    "state": "WI",
    "zip": "53105",
    "phone": "+12629494039",
    "type": "shop",
    "lat": 42.7048877,
    "lng": -88.3261727
  },
  {
    "name": "Mimzie's Coffee and Curiosities",
    "address": "16426 Highway 72, Rogersville, AL 35652-8117",
    "city": "Rogersville",
    "state": "AL",
    "zip": "35652-8117",
    "phone": "+12566686364",
    "type": "shop",
    "lat": 34.8227512,
    "lng": -87.29046730000002
  },
  {
    "name": "Cool Creations",
    "address": "2820 Indiana Avenue, Pensacola, FL 32526",
    "city": "Pensacola",
    "state": "FL",
    "zip": "32526",
    "phone": "+18502000571",
    "type": "shop",
    "lat": 30.4720023,
    "lng": -87.29653789999999
  },
  {
    "name": "Off The Beaten Path Antiques & Gifts, LLC",
    "address": "1029 Coleman Drive, McCalla, AL 35111",
    "city": "McCalla",
    "state": "AL",
    "zip": "35111",
    "phone": "+12059134200",
    "type": "shop",
    "lat": 33.3181697,
    "lng": -87.0571003
  },
  {
    "name": "Erin's Elderberries, LLC",
    "address": "4257 Aiken Drive, Warrenton, VA 20187",
    "city": "Warrenton",
    "state": "VA",
    "zip": "20187",
    "phone": "+15716120209",
    "type": "shop",
    "lat": 38.7437661,
    "lng": -77.6827292
  },
  {
    "name": "One Room Escapes & Coffee",
    "address": "512 Coleman Drive, Lompoc, CA 93436",
    "city": "Lompoc",
    "state": "CA",
    "zip": "93436",
    "phone": "+18052943774",
    "type": "shop",
    "lat": 34.6630249,
    "lng": -120.4521812
  },
  {
    "name": "Thistle Fields - Willowbrook",
    "address": "7625 Bailey Cove RD SE, Huntsville, AL 35802",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35802",
    "phone": "+12563480719",
    "type": "shop",
    "lat": 34.6685934,
    "lng": -86.53750819999999
  },
  {
    "name": "Guest Services - Big Sur Lodge",
    "address": "47255 Highway 1, Big Sur, CA 93920",
    "city": "Big Sur",
    "state": "CA",
    "zip": "93920",
    "phone": "+18816373108",
    "type": "shop",
    "lat": 36.0496331,
    "lng": -121.5898045
  },
  {
    "name": "Carbon2Cobalt",
    "address": "2021 Cabot Place, Oxnard, CA 93030",
    "city": "Oxnard",
    "state": "CA",
    "zip": "93030",
    "phone": "+12195087989",
    "type": "shop",
    "lat": 34.2012258,
    "lng": -119.1532104
  },
  {
    "name": "Arizona Wildflowers And Gifs",
    "address": "616 North Beeline Highway, Payson, AZ 85541",
    "city": "Payson",
    "state": "AZ",
    "zip": "85541",
    "phone": "+19283634080",
    "type": "shop",
    "lat": 34.2487352,
    "lng": -111.3232449
  },
  {
    "name": "Loose Brick Coffee Co",
    "address": "128 West Court Square, Ozark, AL 36360",
    "city": "Ozark",
    "state": "AL",
    "zip": "36360",
    "phone": "+13342370948",
    "type": "shop",
    "lat": 31.45825249999999,
    "lng": -85.6411079
  },
  {
    "name": "Dare Gift Boxes",
    "address": "22743 Evergreen Mills Rd, Leesburg, VA 20175",
    "city": "Leesburg",
    "state": "VA",
    "zip": "20175",
    "phone": "+17035422121",
    "type": "shop",
    "lat": 39.0847356,
    "lng": -77.5723575
  },
  {
    "name": "Harrison County Parks Department",
    "address": "126 E. Walnut St, Corydon, IN 47112",
    "city": "Corydon",
    "state": "IN",
    "zip": "47112",
    "phone": "8127388236",
    "type": "shop",
    "lat": 38.21231,
    "lng": -86.125219
  },
  {
    "name": "Designers Furniture Resource",
    "address": "2200 Main Street, Santa Monica, CA 90405",
    "city": "Santa Monica",
    "state": "CA",
    "zip": "90405",
    "phone": "4245816098",
    "type": "shop",
    "lat": 34.00545,
    "lng": -118.487287
  },
  {
    "name": "City Coffee",
    "address": "9 Sunnybrook Drive, New Castle, PA 16105",
    "city": "New Castle",
    "state": "PA",
    "zip": "16105",
    "phone": "7249442213",
    "type": "shop",
    "lat": 41.0306366,
    "lng": -80.3723519
  },
  {
    "name": "Southern Sophistication",
    "address": "52 Lani Circle, Laceys Spring, AL 35754",
    "city": "Laceys Spring",
    "state": "AL",
    "zip": "35754",
    "phone": "2565661626",
    "type": "shop",
    "lat": 34.5272682,
    "lng": -86.6037994
  },
  {
    "name": "Trickey's Brews and Bevs",
    "address": "120 West Locust St, Boonville, IN 47601",
    "city": "Boonville",
    "state": "IN",
    "zip": "47601",
    "phone": "+16158128412",
    "type": "shop",
    "lat": 38.0488371,
    "lng": -87.275031
  },
  {
    "name": "The Coffee Tree",
    "address": "223 W Maple Street, Lancaster, WI 53813",
    "city": "Lancaster",
    "state": "WI",
    "zip": "53813",
    "phone": "+16087230238",
    "type": "shop",
    "lat": 42.8482214,
    "lng": -90.7113818
  },
  {
    "name": "Home Decor",
    "address": "928 Main St, Evanston, WY 82930",
    "city": "Evanston",
    "state": "WY",
    "zip": "82930",
    "phone": "+13077891560",
    "type": "shop",
    "lat": 41.2676151,
    "lng": -110.9653188
  },
  {
    "name": "D’Andrews Bakery & Cafe",
    "address": "555 Church Street, Nashville, TN 37219",
    "city": "Nashville",
    "state": "TN",
    "zip": "37219",
    "phone": "+16159483378",
    "type": "shop",
    "lat": 36.1624377,
    "lng": -86.7811657
  },
  {
    "name": "P&J Adventures",
    "address": "276 Woodmont Dr, Union Grove, AL 35175",
    "city": "Union Grove",
    "state": "AL",
    "zip": "35175",
    "phone": "+14083064975",
    "type": "shop",
    "lat": 34.4247421,
    "lng": -86.56934009999999
  },
  {
    "name": "Pie Bar",
    "address": "771 Shallowford Road Northeast, Kennesaw, GA 30144",
    "city": "Kennesaw",
    "state": "GA",
    "zip": "30144",
    "phone": "+14045365100",
    "type": "shop",
    "lat": 34.0234337,
    "lng": -84.6154897
  },
  {
    "name": "My Darling & Co.",
    "address": "104 South Main Street, Versailles, KY 40383",
    "city": "Versailles",
    "state": "KY",
    "zip": "40383",
    "phone": "+17316952900",
    "type": "shop",
    "lat": 38.0526721,
    "lng": -84.7302416
  },
  {
    "name": "Tia's",
    "address": "500 West Fulton Street, Sinton, TX 78387",
    "city": "Sinton",
    "state": "TX",
    "zip": "78387",
    "phone": "+18325179667",
    "type": "shop",
    "lat": 28.0392294,
    "lng": -97.5155795
  },
  {
    "name": "The Pinehurst Olive Oil Company",
    "address": "105 Cherokee Road, Pinehurst, NC 28374",
    "city": "Pinehurst",
    "state": "NC",
    "zip": "28374",
    "phone": "+19109860880",
    "type": "shop",
    "lat": 35.19496880000001,
    "lng": -79.4694612
  },
  {
    "name": "Table Rock Coffee Roasters",
    "address": "162 Industrial Park Dr, Hollister, MO 65672",
    "city": "Hollister",
    "state": "MO",
    "zip": "65672",
    "phone": "+14173191595",
    "type": "shop",
    "lat": 36.6093685,
    "lng": -93.22472350000001
  },
  {
    "name": "Montana Coffee Company",
    "address": "3 Cricket Hill Road, Flintville, TN 37335",
    "city": "Flintville",
    "state": "TN",
    "zip": "37335",
    "phone": "+19316910069",
    "type": "shop",
    "lat": 35.0627553,
    "lng": -86.4483305
  },
  {
    "name": "Public Square Marketplace",
    "address": "120 North College Street, Lebanon, TN 37087",
    "city": "Lebanon",
    "state": "TN",
    "zip": "37087",
    "phone": "+16155476621",
    "type": "shop",
    "lat": 36.2081544,
    "lng": -86.28979
  },
  {
    "name": "Rivertown Coffee",
    "address": "117 North Seminary Street, Florence, AL 35630",
    "city": "Florence",
    "state": "AL",
    "zip": "35630",
    "phone": "+12564122128",
    "type": "shop",
    "lat": 34.801288,
    "lng": -87.6751326
  },
  {
    "name": "Swamp Rabbit Cafe and Grocery",
    "address": "1424 Hampton Avenue Extension, Greenville, SC 29601",
    "city": "Greenville",
    "state": "SC",
    "zip": "29601",
    "phone": "+18642553385",
    "type": "shop",
    "lat": 34.8681291,
    "lng": -82.4195446
  },
  {
    "name": "Essential Church",
    "address": "2026 Sewanee Road Southwest, Huntsville, AL 35801",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35801",
    "phone": "+12563374186",
    "type": "shop",
    "lat": 34.7174561,
    "lng": -86.5863225
  },
  {
    "name": "Honest Coffee Roaster",
    "address": "114 Clinton Avenue East, Huntsville, AL 35801",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35801",
    "phone": "+12564794653",
    "type": "shop",
    "lat": 34.731396,
    "lng": -86.5861231
  },
  {
    "name": "Shenella Craig",
    "address": "75 N Piney Rd, Story, WY 82842",
    "city": "Story",
    "state": "WY",
    "zip": "82842",
    "phone": "",
    "type": "shop",
    "lat": 44.5788956,
    "lng": -106.8992218
  },
  {
    "name": "The Farm Company",
    "address": "105 S Main St, Columbiana, AL 35051",
    "city": "Columbiana",
    "state": "AL",
    "zip": "35051",
    "phone": "+12056715477",
    "type": "shop",
    "lat": 33.1780057,
    "lng": -86.60687949999999
  },
  {
    "name": "The Maker and Merchant Auburn",
    "address": "1627 Opelika Road, Auburn, AL 36830",
    "city": "Auburn",
    "state": "AL",
    "zip": "36830",
    "phone": "+17067285989",
    "type": "shop",
    "lat": 32.6266835,
    "lng": -85.447228
  },
  {
    "name": "Downtown Coffee and Cream",
    "address": "140 Maple Street, Whiting, IA 51063-1015",
    "city": "Whiting",
    "state": "IA",
    "zip": "51063-1015",
    "phone": "+12622247277",
    "type": "shop",
    "lat": 42.120719,
    "lng": -96.150701
  },
  {
    "name": "Hygge Life",
    "address": "108 Delilah Lane, Madison, AL 35756",
    "city": "Madison",
    "state": "AL",
    "zip": "35756",
    "phone": "+14176313230",
    "type": "shop",
    "lat": 34.6052621,
    "lng": -86.7414146
  },
  {
    "name": "Oakwood Farms Market",
    "address": "7000 Adventist Blvd, Huntsville, AL 35896",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35896",
    "phone": "+16145303550",
    "type": "shop",
    "lat": 34.7521584,
    "lng": -86.6557875
  },
  {
    "name": "ATTN:  O'Henry's",
    "address": "800 Lakeshore Drive, Birmingham, AL 35229",
    "city": "Birmingham",
    "state": "AL",
    "zip": "35229",
    "phone": "+12054715024",
    "type": "shop",
    "lat": 33.4638283,
    "lng": -86.79716669999999
  },
  {
    "name": "The Museum Shop, Birmingham Museum of Art",
    "address": "BMA Museum Store, Birmingham, AL 35203",
    "city": "Birmingham",
    "state": "AL",
    "zip": "35203",
    "phone": "+12052542777",
    "type": "shop",
    "lat": 33.5222317,
    "lng": -86.8100742
  },
  {
    "name": "Hebrews Coffee Shop",
    "address": "5511 Main Street, Hokes Bluff, AL 35903",
    "city": "Hokes Bluff",
    "state": "AL",
    "zip": "35903",
    "phone": "2566221400",
    "type": "shop",
    "lat": 33.9970785,
    "lng": -85.8673513
  },
  {
    "name": "Raging Gazebo Comics & Games",
    "address": "8760 Madison Boulevard, Madison, AL 35758",
    "city": "Madison",
    "state": "AL",
    "zip": "35758",
    "phone": "+12562786597",
    "type": "shop",
    "lat": 34.6802114,
    "lng": -86.74588039999999
  },
  {
    "name": "Its Koffee Time",
    "address": "1 Tanager Dr, Ringoes, NJ 08551",
    "city": "Ringoes",
    "state": "NJ",
    "zip": "08551",
    "phone": "6095800744",
    "type": "shop",
    "lat": 40.4469512,
    "lng": -74.8500069
  },
  {
    "name": "Picture This",
    "address": "11401 Old Glenn Highway, Eagle River, AK 99577",
    "city": "Eagle River",
    "state": "AK",
    "zip": "99577",
    "phone": "+19072276787",
    "type": "shop",
    "lat": 61.32323029999999,
    "lng": -149.5695585
  },
  {
    "name": "Alison Grooms",
    "address": "519 Birkdale Blvd., Carrollton, GA 30116",
    "city": "Carrollton",
    "state": "GA",
    "zip": "30116",
    "phone": "+14049251072",
    "type": "shop",
    "lat": 33.5683458,
    "lng": -85.02925110000001
  },
  {
    "name": "Wholy Beans Coffee Co.",
    "address": "3145 Lindale-Mt Holly Road, Amelia, OH 45102",
    "city": "Amelia",
    "state": "OH",
    "zip": "45102",
    "phone": "+15138080302",
    "type": "shop",
    "lat": 39.0004909,
    "lng": -84.1823185
  },
  {
    "name": "Mitizi's Sonoma",
    "address": "202 East Louisiana Street, McKinney, TX 75069",
    "city": "McKinney",
    "state": "TX",
    "zip": "75069",
    "phone": "+14696785083",
    "type": "shop",
    "lat": 33.1974439,
    "lng": -96.6167625
  },
  {
    "name": "OHenry's Coffee Roasting Company",
    "address": "300 Carlow Lane, Birmingham, AL 35242",
    "city": "Birmingham",
    "state": "AL",
    "zip": "35242",
    "phone": "+12512290996",
    "type": "shop",
    "lat": 33.4076856,
    "lng": -86.6313484
  },
  {
    "name": "Alpine Olive Tree",
    "address": "8656 North Main Street, Helen, GA 30545",
    "city": "Helen",
    "state": "GA",
    "zip": "30545",
    "phone": "+12563664549",
    "type": "shop",
    "lat": 34.7013689,
    "lng": -83.7307627
  },
  {
    "name": "Bella's Bagels",
    "address": "1405 NW Central Ave, Seaside Park, NJ 08752",
    "city": "Seaside Park",
    "state": "NJ",
    "zip": "08752",
    "phone": "+17323307757",
    "type": "shop",
    "lat": 39.9335264,
    "lng": -74.0770623
  },
  {
    "name": "Walnut Hill Coffee Co.",
    "address": "100 First Avenue NW, Winchester, TN 37398",
    "city": "Winchester",
    "state": "TN",
    "zip": "37398",
    "phone": "+19315800624",
    "type": "shop",
    "lat": 35.1863917,
    "lng": -86.1125204
  },
  {
    "name": "Fork of the South General Store",
    "address": "5518 Hargrove Ridge Road, Franklin, TN 37064",
    "city": "Franklin",
    "state": "TN",
    "zip": "37064",
    "phone": "+16154972402",
    "type": "shop",
    "lat": 35.9206811,
    "lng": -87.0437788
  },
  {
    "name": "Otisco bakery",
    "address": "5011 Whites Bridge Rd, Belding, MI 48809",
    "city": "Belding",
    "state": "MI",
    "zip": "48809",
    "phone": "+16162443444",
    "type": "shop",
    "lat": 43.0593644,
    "lng": -85.26336479999999
  },
  {
    "name": "Earth's Elements",
    "address": "103 E. Main St, Walhalla, SC 29691",
    "city": "Walhalla",
    "state": "SC",
    "zip": "29691",
    "phone": "+18649164001",
    "type": "shop",
    "lat": 34.7652581,
    "lng": -83.0653954
  },
  {
    "name": "Haefeli Honey",
    "address": "425 Grand Ave, Del Norte, CO 81132",
    "city": "Del Norte",
    "state": "CO",
    "zip": "81132",
    "phone": "+17198491356",
    "type": "shop",
    "lat": 37.6787932,
    "lng": -106.3569109
  },
  {
    "name": "TAT Enterprises",
    "address": "337 Manitou Ave, Manitou Springs, CO 80829",
    "city": "Manitou Springs",
    "state": "CO",
    "zip": "80829",
    "phone": "+17196859045",
    "type": "shop",
    "lat": 38.8567344,
    "lng": -104.9017935
  },
  {
    "name": "Jenny's Floral",
    "address": "21 North 4th Street, Custer, SD 57730",
    "city": "Custer",
    "state": "SD",
    "zip": "57730",
    "phone": "+16056733549",
    "type": "shop",
    "lat": 43.7662225,
    "lng": -103.6023784
  },
  {
    "name": "Lab Discount Drugs, Inc",
    "address": "923 Wayne Street, Waynesboro, MS 39367",
    "city": "Waynesboro",
    "state": "MS",
    "zip": "39367",
    "phone": "+16017354444",
    "type": "shop",
    "lat": 31.6771032,
    "lng": -88.6374928
  },
  {
    "name": "The Enchanted Forest",
    "address": "5580 Chamblee Dunwoody Road, Suite 6, Dunwoody, GA 30338",
    "city": "Dunwoody",
    "state": "GA",
    "zip": "30338",
    "phone": "+17703991923",
    "type": "shop",
    "lat": 33.95127,
    "lng": -84.3377921
  },
  {
    "name": "Have a Cow Cattle Company",
    "address": "2742 Lafayette Avenue, St. Louis, MO 63104",
    "city": "St. Louis",
    "state": "MO",
    "zip": "63104",
    "phone": "+13143978689",
    "type": "shop",
    "lat": 38.6150185,
    "lng": -90.2250451
  },
  {
    "name": "Pittman’s Country Market",
    "address": "364 Cedar Crossing Road, Lyons, GA 30436",
    "city": "Lyons",
    "state": "GA",
    "zip": "30436",
    "phone": "+19122455058",
    "type": "shop",
    "lat": 31.9727327,
    "lng": -82.3640697
  },
  {
    "name": "Soggy bottom mercantile",
    "address": "81 Broad Street, Warm Springs, GA 31830",
    "city": "Warm Springs",
    "state": "GA",
    "zip": "31830",
    "phone": "+17067181040",
    "type": "shop",
    "lat": 32.8908082,
    "lng": -84.6798783
  },
  {
    "name": "Gathering Grounds Coffee Shop",
    "address": "337 East Main Street, Russels Point, OH 43348",
    "city": "Russels Point",
    "state": "OH",
    "zip": "43348",
    "phone": "+19374416511",
    "type": "shop",
    "lat": 40.4704168,
    "lng": -83.89104379999999
  },
  {
    "name": "One Utopia",
    "address": "12808 Lakeview Avenue, Clermont, FL 34711",
    "city": "Clermont",
    "state": "FL",
    "zip": "34711",
    "phone": "+14075757616",
    "type": "shop",
    "lat": 28.5330463,
    "lng": -81.7421037
  },
  {
    "name": "Hartmann Farmhouse LLC",
    "address": "2251 Broadway, Grand Junction, CO 81507",
    "city": "Grand Junction",
    "state": "CO",
    "zip": "81507",
    "phone": "+19706406796",
    "type": "shop",
    "lat": 39.0773825,
    "lng": -108.6342628
  },
  {
    "name": "The Moon Bakeshop",
    "address": "201 Jefferson Street, Huntsville, AL 35801",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35801",
    "phone": "+12566563142",
    "type": "shop",
    "lat": 34.7323291,
    "lng": -86.58850749999999
  },
  {
    "name": "Carter Mountain Orchard",
    "address": "1435 Carters Mountain Trail, Charlottesville, VA 22902",
    "city": "Charlottesville",
    "state": "VA",
    "zip": "22902",
    "phone": "+14349771833",
    "type": "shop",
    "lat": 37.9913221,
    "lng": -78.4720494
  },
  {
    "name": "Synchronici-Tea Lounge",
    "address": "3755 Redwine Rd, Atlanta, GA 30344",
    "city": "Atlanta",
    "state": "GA",
    "zip": "30344",
    "phone": "+12565032739",
    "type": "shop",
    "lat": 33.662227,
    "lng": -84.50381449999999
  },
  {
    "name": "Star Super Market",
    "address": "702 Pratt Avenue Northeast, Huntsville, AL 35801",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35801",
    "phone": "+12565344509",
    "type": "shop",
    "lat": 34.7385965,
    "lng": -86.5763211
  },
  {
    "name": "Two Sisters Teahouse",
    "address": "209 North Front Street, Aledo, TX 76008",
    "city": "Aledo",
    "state": "TX",
    "zip": "76008",
    "phone": "+18175077527",
    "type": "shop",
    "lat": 32.6962964,
    "lng": -97.6021253
  },
  {
    "name": "Erie Islands Ventures, Inc",
    "address": "7744 Baumhart Rd, Amherst, OH 44001",
    "city": "Amherst",
    "state": "OH",
    "zip": "44001",
    "phone": "+14408232990",
    "type": "shop",
    "lat": 41.3863288,
    "lng": -82.2833598
  },
  {
    "name": "Vulcan Park and Museum",
    "address": "1701 Valley View Drive, Birmingham, AL 35209",
    "city": "Birmingham",
    "state": "AL",
    "zip": "35209",
    "phone": "+12059371441",
    "type": "shop",
    "lat": 33.4905651,
    "lng": -86.79472659999999
  },
  {
    "name": "White House Fruit Farm",
    "address": "9249 Youngstown - Salem Road, Canfield, OH 44406",
    "city": "Canfield",
    "state": "OH",
    "zip": "44406",
    "phone": "+13307178985",
    "type": "shop",
    "lat": 40.9848839,
    "lng": -80.8063978
  },
  {
    "name": "Heritage House Coffee",
    "address": "700 Towncenter Boulevard, Tuscaloosa, AL 35406",
    "city": "Tuscaloosa",
    "state": "AL",
    "zip": "35406",
    "phone": "+12054544617",
    "type": "shop",
    "lat": 33.2330359,
    "lng": -87.5367167
  },
  {
    "name": "Mike Lotter",
    "address": "3720 East Lamar Alexander Parkway, Maryville, TN 37804",
    "city": "Maryville",
    "state": "TN",
    "zip": "37804",
    "phone": "+18658045150",
    "type": "shop",
    "lat": 35.7586185,
    "lng": -83.8671281
  },
  {
    "name": "Kenzie Smelker",
    "address": "318 Emerson St, Wray, CO 80758",
    "city": "Wray",
    "state": "CO",
    "zip": "80758",
    "phone": "+17197513182",
    "type": "shop",
    "lat": 40.0782608,
    "lng": -102.2285414
  },
  {
    "name": "Mezza Luna",
    "address": "2724 Carl T Jones Dr, Huntsville, AL 35802",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35802",
    "phone": "+12566896546",
    "type": "shop",
    "lat": 34.6750091,
    "lng": -86.5474636
  },
  {
    "name": "Amy Lucas",
    "address": "111 Kelso-Smithland Road, Kelso, TN 37348",
    "city": "Kelso",
    "state": "TN",
    "zip": "37348",
    "phone": "+12565858828",
    "type": "shop",
    "lat": 35.123756,
    "lng": -86.4490945
  },
  {
    "name": "Shaffer Coffee Co.",
    "address": "404A North 4th Street, Murray, KY 42071",
    "city": "Murray",
    "state": "KY",
    "zip": "42071",
    "phone": "+12707670101",
    "type": "shop",
    "lat": 36.6149609,
    "lng": -88.30148299999999
  },
  {
    "name": "Earth and Stone Wood Fired Pizza",
    "address": "2600 Clinton Avenue West, Huntsville, AL 35805",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35805",
    "phone": "+12563909212",
    "type": "shop",
    "lat": 34.7270479,
    "lng": -86.5945478
  },
  {
    "name": "Flint River Coffee",
    "address": "1443 Winchester Road Northeast, Huntsville, AL 35811",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35811",
    "phone": "+12568590109",
    "type": "shop",
    "lat": 34.8058315,
    "lng": -86.520207
  },
  {
    "name": "Rooster's Crow Coffee Roastery",
    "address": "8402 Whitesburg Drive, Huntsville, AL 35802",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35802",
    "phone": "+12567630805",
    "type": "shop",
    "lat": 34.6544294,
    "lng": -86.5668858
  },
  {
    "name": "White Horse Coffee Roasters & Sustainable Marketplace",
    "address": "7501 Woodlawn Ave, Elkins Park, PA 19027",
    "city": "Elkins Park",
    "state": "PA",
    "zip": "19027",
    "phone": "+12152640929",
    "type": "shop",
    "lat": 40.0770553,
    "lng": -75.1268413
  },
  {
    "name": "Shelley Fitzpatrick",
    "address": "11301 W MAPLE RAPIDS RD, FOWLER, MI 48835",
    "city": "FOWLER",
    "state": "MI",
    "zip": "48835",
    "phone": "+19899443482",
    "type": "shop",
    "lat": 43.0017113,
    "lng": -84.7398622
  },
  {
    "name": "Piggly Wiggly Clairmont Avenue",
    "address": "3314 Clairmont Avenue, Birmingham, AL 35222",
    "city": "Birmingham",
    "state": "AL",
    "zip": "35222",
    "phone": "+12052520684",
    "type": "shop",
    "lat": 33.5132177,
    "lng": -86.78051479999999
  },
  {
    "name": "The Mad Herbalist",
    "address": "910 Max Court, Clarksville, TN 37043",
    "city": "Clarksville",
    "state": "TN",
    "zip": "37043",
    "phone": "+19318018386",
    "type": "shop",
    "lat": 36.5022737,
    "lng": -87.32331669999999
  },
  {
    "name": "Plentiful Produce",
    "address": "1103 Pratt Ave. NE, Huntsville, AL 35801",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35801",
    "phone": "+12566794386",
    "type": "shop",
    "lat": 34.73897900000001,
    "lng": -86.5728408
  },
  {
    "name": "Priester's Pecans",
    "address": "1575 Old Fort Road East, Fort Deposit, AL 36032",
    "city": "Fort Deposit",
    "state": "AL",
    "zip": "36032",
    "phone": "+13342278355",
    "type": "shop",
    "lat": 31.9845929,
    "lng": -86.5785856
  },
  {
    "name": "Buzzcatz Coffee",
    "address": "25689 Canal Rd Unit A, Orange Beach, AL 36561",
    "city": "Orange Beach",
    "state": "AL",
    "zip": "36561",
    "phone": "+12519802899",
    "type": "shop",
    "lat": 30.2918041,
    "lng": -87.5865007
  },
  {
    "name": "The RED POPPY",
    "address": "4910 Lincoln Avenue, Evansville, IN 47715",
    "city": "Evansville",
    "state": "IN",
    "zip": "47715",
    "phone": "+18127593312",
    "type": "shop",
    "lat": 37.97010040000001,
    "lng": -87.49125649999999
  },
  {
    "name": "Summit Crossing Church",
    "address": "7200 Governors West, Huntsville, AL 35806",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35806",
    "phone": "+12563259905",
    "type": "shop",
    "lat": 34.7042211,
    "lng": -86.6851316
  },
  {
    "name": "My Big Finds",
    "address": "129 Commerce Square Place, Gaithersburg, MD 20878",
    "city": "Gaithersburg",
    "state": "MD",
    "zip": "20878",
    "phone": "+13017044091",
    "type": "shop",
    "lat": 39.1222597,
    "lng": -77.2345654
  },
  {
    "name": "The Cookery",
    "address": "1827 12th Avenue South, Nashville, TN 37203",
    "city": "Nashville",
    "state": "TN",
    "zip": "37203",
    "phone": "6152692911",
    "type": "shop",
    "lat": 36.13508789999999,
    "lng": -86.7893157
  },
  {
    "name": "Hendersonville Produce",
    "address": "760 East Main Street, Hendersonville, TN 37075",
    "city": "Hendersonville",
    "state": "TN",
    "zip": "37075",
    "phone": "+16158260033",
    "type": "shop",
    "lat": 36.3269338,
    "lng": -86.56344709999999
  },
  {
    "name": "The Garlic Press",
    "address": "108 West North Street, Normal Township, IL 61761",
    "city": "Normal Township",
    "state": "IL",
    "zip": "61761",
    "phone": "+13094528841",
    "type": "shop",
    "lat": 40.5097509,
    "lng": -88.9850209
  },
  {
    "name": "Lawren's",
    "address": "809 Madison Street, Huntsville, AL 35801",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35801",
    "phone": "+12565344428",
    "type": "shop",
    "lat": 34.7221362,
    "lng": -86.5797539
  },
  {
    "name": "The Farmhouse Kitchen",
    "address": "183 Old Mill Ave, Pigeon Forge, TN 37863",
    "city": "Pigeon Forge",
    "state": "TN",
    "zip": "37863",
    "phone": "+18657748935",
    "type": "shop",
    "lat": 35.7891046,
    "lng": -83.5528295
  },
  {
    "name": "Tate Farm",
    "address": "8414 Moores Mill Rd, Meridianville, AL 35759",
    "city": "Meridianville",
    "state": "AL",
    "zip": "35759",
    "phone": "+12569905765",
    "type": "shop",
    "lat": 34.8745959,
    "lng": -86.51102399999999
  },
  {
    "name": "The Bookshelf",
    "address": "126 South Broad Street, Thomasville, GA 31792",
    "city": "Thomasville",
    "state": "GA",
    "zip": "31792",
    "phone": "+12292287767",
    "type": "shop",
    "lat": 30.8365551,
    "lng": -83.9797751
  },
  {
    "name": "Josie's Gift Shop",
    "address": "3101 Burritt Dr SE, Huntsville, AL 35801",
    "city": "Huntsville",
    "state": "AL",
    "zip": "35801",
    "phone": "+12565362882",
    "type": "shop",
    "lat": 34.7159658,
    "lng": -86.5397137
  },
  {
    "name": "Alabama Goods",
    "address": "2933 18th Street South, Homewood, AL 35209",
    "city": "Homewood",
    "state": "AL",
    "zip": "35209",
    "phone": "+12058033900",
    "type": "shop",
    "lat": 33.4784911,
    "lng": -86.7914189
  },
  {
    "name": "The Candy Shop",
    "address": "1029 Main Street, Oconto, WI 54153",
    "city": "Oconto",
    "state": "WI",
    "zip": "54153",
    "phone": "+19203716039",
    "type": "shop",
    "lat": 44.887955,
    "lng": -87.868484
  },
  {
    "name": "J J's Collectables, LLC",
    "address": "922 10th Street, Onawa, IA 51040",
    "city": "Onawa",
    "state": "IA",
    "zip": "51040",
    "phone": "+17124332655",
    "type": "shop",
    "lat": 42.0273395,
    "lng": -96.0976599
  },
  {
    "name": "Kyra Lloyd",
    "address": "208 Canyon Loop, Boerne, TX 78006",
    "city": "Boerne",
    "state": "TX",
    "zip": "78006",
    "phone": "+12108853690",
    "type": "shop",
    "lat": 29.7382428,
    "lng": -98.7823791
  },
  {
    "name": "Cafe Au Latte",
    "address": "1011 Paris Road, Mayfield, KY 42066",
    "city": "Mayfield",
    "state": "KY",
    "zip": "42066",
    "phone": "+12709700490",
    "type": "shop",
    "lat": 36.7277493,
    "lng": -88.6309198
  }
];
